class SubscriptionCreditInfo implements ng.IComponentController {
    planName: string;
    period: string;
    price: number;
    annualDiscount: number;
    percentsDiscount: number;
    amountDiscount: number;
    credit: number;
}

angular.module('animatronApp.SubscriptionCreditInfo', [])
    .component('subscriptionCreditInfo', {
        bindings: {
            planName: '<',
            period: '<',
            price: '<',
            annualDiscount: '<',
            percentsDiscount: '<',
            amountDiscount: '<',
            credit: '<'
        },
        controller: SubscriptionCreditInfo,
        templateUrl: require('settings/subscription/subscription-credit-info.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionCreditInfo.ts